import { render, staticRenderFns } from "./CashierSales.vue?vue&type=template&id=16bfdef3"
import script from "./CashierSales.vue?vue&type=script&lang=js"
export * from "./CashierSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports